import { render, staticRenderFns } from "./LanguagesSkeleton.vue?vue&type=template&id=40d08c0e&scoped=true&"
import script from "./LanguagesSkeleton.vue?vue&type=script&lang=js&"
export * from "./LanguagesSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./LanguagesSkeleton.vue?vue&type=style&index=0&id=40d08c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d08c0e",
  null
  
)

export default component.exports